import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const WalletIcon = ({ size = 22, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 7a2 2 0 0 1 2-2h12l2 2H5a2 2 0 0 1-2-2z" />
    <path d="M3 7v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9H5a2 2 0 0 1-2-2z" />
    <circle cx="16.5" cy="13.5" r="1.2" fill="currentColor" />
  </svg>
)
